(function (window, document, undefined) {
  'use strict';
  window.tp = window.tp || [];
  let iapButtonNode = false,
    paywallAsModal = false;

  const onIapClicked = () => {
    document.dispatchEvent(new Event( 'vodl-iap-button-clicked' ) );
  };

  const showIapOfferButton = (price) => {
    if (!price || !iapButtonNode) {
      return;
    }

    const priceNode = iapButtonNode.querySelector('.vodl-button__label');

    if (!priceNode) {
      return;
    }

    priceNode.innerHTML = price;
    iapButtonNode.style.display = 'block';
  };

  const onLoginResolved = (ev) => {
    let userData = ev.detail || {};
    userData.piano = userData.piano || {};
    userData.piano.abo = userData.piano.abo || {};

    const rmPiano = window.RussMedia.Piano || false;
  
    if (rmPiano && rmPiano.isPremiumUser(userData.piano.abo) && !paywallAsModal) {
      const subscriptionText = document.querySelector('.vodl-sub-text');
      
      if (subscriptionText) {
        subscriptionText.style.display = 'block';
      }
    }
  };

  const init = () => {
    iapButtonNode = document.querySelector('.vodl-iap-button');

    if (iapButtonNode) {
      iapButtonNode.addEventListener('click', onIapClicked);
    }

    const pianoData = document.querySelector('#pianoData');
    let parsedData = {};

    if (null !== pianoData) {
      parsedData = JSON.parse(pianoData.innerHTML);
    }

    const triggerManually = parsedData.triggerManual || false;
    paywallAsModal = parsedData.paywallAsModal || false;

    if (window.location.href.includes('noheader') && !triggerManually && paywallAsModal) {
      document.dispatchEvent(new Event('vodl-iap-button-clicked'));
    }

    window.addEventListener('vodl_piano_on_login_resolved', onLoginResolved);
  };

  init();

  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Piano = window.RussMedia.Piano || {};
  $.extend(window.RussMedia.Piano, {
    showIapOfferButton: showIapOfferButton,
  });
})(window, document);